const isDomainDisabled = [''].includes(window.location.hostname);

export { isDomainDisabled };
